import { ID } from '@datorama/akita';
import { Observable } from 'rxjs';

import { Column, Entity, OneToMany } from '../entity';
import { Result } from '../interfaces/helpers';
import { IEntity } from '../interfaces/models';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';
import { ValueService } from '../services/value';
import { Value } from './value.model';

export interface IPicklist extends IEntity {
  picklistName: string;
  description: string;
  picklistValue: number[];
  valueList?: Observable<Result<Value>>;
}

@Entity({
  name: PageTitles.appConfig,
  language: LanguagePage.appConfig,
})
export class Picklist implements IPicklist {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
    form: {
      defaultPosition: 1,
    },
  })
  picklistName: string;

  @Column({
    type: ColumnType.string,
    isEditable: true,
    table: {
      defaultPosition: 2,
    },
    form: {
      defaultPosition: 2,
    },
  })
  description: string;

  @Column({
    type: ColumnType.array,
    table: {
      defaultPosition: 3,
    },
  })
  picklistValue: number[];

  @OneToMany({
    repository: ValueService,
    expression: { picklistId: (i: Picklist) => i.id },
  })
  valueList: Observable<Result<Value>>;

  id: ID;
  createdAt?: Date;
  modifiedAt?: Date;
  createdBy?: string;
  modifiedBy?: string;
  href?: string;

  constructor(
    picklist: IPicklist = {
      id: '',
      picklistName: '',
      description: '',
      picklistValue: [],
    }
  ) {
    const { id, picklistName, description, picklistValue } = picklist;

    this.id = id;
    this.picklistName = picklistName;
    this.description = description;
    this.picklistValue = picklistValue;
  }

  static createFromDTO(record: IPicklist): Picklist {
    return new Picklist({
      ...record,
      modifiedAt: record.modifiedAt ? new Date(record.modifiedAt) : null,
      createdAt: record.createdAt ? new Date(record.createdAt) : null,
    });
  }
}
